// Internal modules
import { features } from '@/lib/features';
import { isUserActionCommit } from '@/lib/globals';

const getButtonCurrencyCode = (conversionData, selection) => {
  // Checking `from` prop because the default for the currency conversion data
  // is an empty object, which is truthy, so we can't just check `if (!data)`
  if (!conversionData?.from) {
    return '';
  }

  const conversionType = selection === 'VENDOR' ? 'to' : 'from';
  return conversionData[conversionType]?.currencyCode;
};

const getFlowName = accountType => {
  if (accountType === 'signup') {
    return features.isActive('isPOMAEligible') ? 'poma' : 'signup';
  }

  return 'guest';
};

const getSubFlow = withConversion => {
  if (features.isActive('isDonation')) {
    return 'donate';
  }

  // Content is the same as the base content for useraction='commit'
  // when conversion is needed
  const isCommit = !withConversion && isUserActionCommit();

  return isCommit ? 'commit' : 'base';
};

const getSubmitButtonContentKey = ({ accountType, conversionSelection }) => {
  // If currency conversion is needed, `conversionSelection` will
  // be "PAYPAL" or "VENDOR", otherwise it is an empty string
  const withConversion = Boolean(conversionSelection);
  const flowName = getFlowName(accountType);
  const subFlow = getSubFlow(withConversion);

  const components = [
    'buttons',
    flowName,
    withConversion && 'withConversion',
    subFlow,
  ];

  return components.filter(Boolean).join('.');
};

export {
  getButtonCurrencyCode,
  getFlowName,
  getSubFlow,
  getSubmitButtonContentKey,
};
